export default __webpack_public_path__ + "static/media/HondaBG.ef6a8a60.png";